module.exports = __webpack_public_path__ + "static/d03-f934bbb6d2e7e83877b013d1fb632411.png";